import { graphql } from "~/gql";

export const ASSIGN_WORKS_TO_PHASE = graphql(/* GraphQL */ `
  mutation assignWorksToPhase($data: [WorkCreateInput!]!) {
    assignWorksToPhase(data: $data) {
      ...WorkParts
    }
  }
`);
